import React from 'react';
import c from 'classnames';

import Stack from '../../../Stack';
import { SELECT_OPTION_CONFIG } from './consts';
import { renderSelectedIndicator } from './renderers';
import { SelectOptionProps } from './types';

function SelectOption(props: SelectOptionProps) {
  const { label, multiple = false, size = 'medium', state } = props;
  const config = SELECT_OPTION_CONFIG[size];

  return (
    <Stack
      alignItems="center"
      className={c('px-12 w-full', config.Root)}
      gapX={8}
      justifyContent="between">
      {label}
      {renderSelectedIndicator({ config, multiple, state })}
    </Stack>
  );
}

export default React.memo(SelectOption);
